import React from "react";
import shared from "./shared.module.scss";
import { Button } from "../../../primary";

export const FormActions = ({ onClick, loading, disabled, label }) => (
  <div className={shared.formActions}>
    <Button type="button" className={shared.primaryButton} onClick={onClick} disabled={disabled || loading}>
      {loading && <span className={shared.custom_spinner} />}
      {label}
    </Button>
  </div>
);
